import { create } from 'zustand';

/* The popup state type  */
export type PopupState = {
    content: any;
    onClose?: () => void;
    open: (content: any, onClose?: () => void) => void;
    close: () => void;
    isOpen: () => boolean;
    setOnClose: (customOnClose: () => void) => void;
};

/* The initial storage state */
export const initialPopupState = {
    content: undefined,
    onClose: undefined,
};

/* The store that keep informations about the global popup */
export const useGlobalPopup = create<PopupState>((set: any, get: any) => ({
    ...initialPopupState,
    setOnClose: (customOnClose: () => void) => {
        set((state: PopupState) => ({ ...state, onClose: customOnClose }));
    },
    isOpen: () => {
        const { content } = get();
        return content !== initialPopupState.content;
    },
    open: (content: any, onClose: () => void = () => {}) => {
        set((state: PopupState) => ({ ...state, content, onClose }));
    },
    close: () => {
        const { onClose } = get();
        if (onClose) onClose();
        set({ ...initialPopupState });
    },
}));
